const createErrorAction = type => (error, payload) => ({
  type,
  error,
  payload,
})

export default createErrorAction
